import { useState, useEffect } from 'react';
import review1 from '../assets/review/1.png';
import review2 from '../assets/review/2.png';
import review3 from '../assets/review/3.png';
import review4 from '../assets/review/4.png';
import review5 from '../assets/review/5.png';
import review6 from '../assets/review/6.png';
import review7 from '../assets/review/7.png';
import review8 from '../assets/review/8.png';

const testimonials = [
    {
        id: 1,
        name: "SARAH",
        title: "SUBSCRIÇÃO IPTV PREMIUM",
        location: "Portugal",
        flag: "🇵🇹",
        image: review1,
        text: "A TVConnect transformou a minha experiência de streaming. A qualidade 4K é excecional e tenho acesso a todos os meus conteúdos preferidos num só lugar. A instalação foi simples e o apoio ao cliente é muito rápido. Recomendo vivamente!"
    },
    {
        id: 2,
        name: "MOHAMED",
        title: "STREAMING MULTIECRÃS",
        location: "Portugal",
        flag: "🇵🇹",
        image: review2,
        text: "Serviço IPTV excelente! Mais de 79 000 canais com uma qualidade impecável. Consigo ver os meus jogos de futebol em direto sem qualquer problema. A relação qualidade‑preço é imbatível. Apoio ao cliente de topo!"
    },
    {
        id: 3,
        name: "EMMA",
        title: "VOD E SÉRIES",
        location: "Portugal",
        flag: "🇵🇹",
        image: review3,
        text: "Adoro a biblioteca de filmes e séries. Mais de 249 000 conteúdos disponíveis! Nunca estive tão satisfeita com um serviço de streaming. A interface é intuitiva e tudo funciona na perfeição."
    },
    {
        id: 4,
        name: "DAVID",
        title: "CANAIS DESPORTIVOS",
        location: "Portugal",
        flag: "🇵🇹",
        image: review4,
        text: "Como fã de desporto, preciso de ter acesso a todos os canais desportivos. A TVConnect dá‑me acesso à Ligue 1 Plus e muito mais. A qualidade HD/4K é perfeita. Serviço muito profissional!"
    },
    {
        id: 5,
        name: "SOPHIE",
        title: "SUBSCRIÇÃO FAMILIAR",
        location: "Portugal",
        flag: "🇵🇹",
        image: review5,
        text: "Perfeito para toda a família! Os meus filhos adoram os canais infantis e temos acesso à Netflix, Disney+ e muito mais. A ativação foi imediata e o suporte está sempre disponível. Obrigada, TVConnect!"
    },
    {
        id: 6,
        name: "ALEX",
        title: "STREAMING ULTRARRÁPIDO",
        location: "Portugal",
        flag: "🇵🇹",
        image: review6,
        text: "A velocidade de ligação é impressionante! Os canais carregam em menos de 0,5 segundos. Também aprecio a compatibilidade com todos os meus dispositivos. O melhor serviço IPTV que testei até agora."
    },
    {
        id: 7,
        name: "LUCAS",
        title: "QUALIDADE 4K",
        location: "Portugal",
        flag: "🇵🇹",
        image: review7,
        text: "A qualidade 4K é excecional! Vejo os meus filmes preferidos com uma nitidez perfeita. O catch‑up e o EPG funcionam muito bem. Estou muito satisfeito com a minha subscrição. Recomendo a 100%!"
    },
    {
        id: 8,
        name: "MARIE",
        title: "SERVIÇO DE APOIO PREMIUM",
        location: "Portugal",
        flag: "🇵🇹",
        image: review8,
        text: "O que mais me impressiona é o apoio ao cliente. Está sempre disponível e é muito competente. Tive uma pequena questão técnica e ajudaram‑me em menos de 10 minutos. Serviço excecional, vou continuar!"
    }
];

export default function Review() {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);

    const currentTestimonial = testimonials[currentIndex];

    // Auto-rotation toutes les 5 secondes
    useEffect(() => {
        const interval = setInterval(() => {
            setIsTransitioning(true);
            setTimeout(() => {
                setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
                setIsTransitioning(false);
            }, 300);
        }, 5000);

        return () => clearInterval(interval);
    }, []);

    const nextSlide = () => {
        setIsTransitioning(true);
        setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
            setIsTransitioning(false);
        }, 300);
    };

    const prevSlide = () => {
        setIsTransitioning(true);
        setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length);
            setIsTransitioning(false);
        }, 300);
    };

    const goToSlide = (index) => {
        setIsTransitioning(true);
        setTimeout(() => {
            setCurrentIndex(index);
            setIsTransitioning(false);
        }, 300);
    };

    return (
        <main className="relative overflow-hidden py-20">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-5">
                <div className="absolute inset-0" style={{
                    backgroundImage: `radial-gradient(circle at 25% 25%, rgba(255, 184, 0, 0.1) 0%, transparent 50%),
                                    radial-gradient(circle at 75% 75%, rgba(255, 184, 0, 0.1) 0%, transparent 50%)`,
                }}></div>
            </div>

            <div className="container mx-auto px-3 sm:px-5 relative z-10">
                {/* Header */}
                <div className="mb-16">
                    <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white">
                        Opiniões dos nossos queridos clientes.
                    </h1>
                </div>

                {/* Main Content */}
                <div className="mb-12">
                    <div className={`grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 transition-opacity duration-300 ${isTransitioning ? 'opacity-50' : 'opacity-100'}`}>
                        {/* Left Side - Image/Video Card */}
                        <div className="relative">
                            <div className="bg-gradient-to-br from-blue-400/20 to-blue-600/20 backdrop-blur-md rounded-2xl overflow-hidden border border-white/10 shadow-2xl">
                                <div className="h-[200px] md:h-[350px]">
                                    <img 
                                        src={currentTestimonial.image} 
                                        alt={currentTestimonial.name}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Testimonial Content */}
                        <div className="flex flex-col justify-center">
                            <div className="h-full">
                                {/* Name */}
                                <h2 className="text-2xl md:text-3xl font-semibold text-white mb-1">
                                    {currentTestimonial.name}
                                </h2>

                                {/* Title */}
                                <p className="text-gray-400 text-xs md:text-sm font-semibold mb-1">
                                    {currentTestimonial.title}
                                </p>

                                {/* Location */}
                                <div className="flex items-center gap-3 mb-8">
                                    <span className="text-2xl">{currentTestimonial.flag}</span>
                                    <span className='font-bold'>{currentTestimonial.location}</span>
                                </div>

                                {/* Testimonial Text */}
                                <p className="text-gray-200 text-base md:text-lg leading-relaxed">
                                    {currentTestimonial.text}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Navigation Controls */}
                <div className="flex items-center justify-center gap-8 relative">
                    {/* Pagination Dots */}
                    <div className="flex items-center gap-2 absolute ">
                        {testimonials.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => goToSlide(index)}
                                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                                    index === currentIndex 
                                        ? 'bg-yellow-400 scale-125' 
                                        : 'bg-gray-400 hover:bg-gray-300'
                                }`}
                                aria-label={`Go to slide ${index + 1}`}
                            />
                        ))}
                    </div>

                    {/* Navigation Arrows */}
                    <div className="flex items-center gap-4 absolute right-0">
                        <button
                            onClick={prevSlide}
                            className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center text-white hover:bg-white/20 transition-all duration-300 hover:scale-110"
                            aria-label="Previous testimonial"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M15.41 7.41L14 6l-6 6l6 6l1.41-1.41L10.83 12z"/>
                            </svg>
                        </button>
                        <button
                            onClick={nextSlide}
                            className="w-12 h-12 rounded-full bg-white/10 backdrop-blur-md border border-white/20 flex items-center justify-center text-white hover:bg-white/20 transition-all duration-300 hover:scale-110"
                            aria-label="Next testimonial"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" viewBox="0 0 24 24">
                                <path fill="currentColor" d="M10 6L8.59 7.41L13.17 12l-4.58 4.59L10 18l6-6z"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </main>
    )
}

